<template>
  <div>
    <div class="lke-titl">
      <div>
        <i class="el-icon-caret-right"></i>
        当前位置：报名登记
      </div>
    </div>
    <div class="lke-mid">
      <div class="lke-mid-top">
        <i class="el-icon-s-order"></i>
        报名登记
      </div>
      <div class="lke-mid-fot">
        <div class="lke-tab1in">
          <div class="lke-tab1in-top">
            <i class="el-icon-star-on"></i>
            报名登记需要准备的材料。
          </div>
        </div>
        <div class="lke-tab1in">
          <div class="lke-tab1in-top">
            <i class="el-icon-star-on"></i>
            如果您有问题可以登录后在学员工作室中提问。会有相应的老师和学员回答您的问题。
          </div>
        </div>
      </div>
    </div>
    <el-tabs v-model="activeName" type="card" v-loading="loading">
      <el-tab-pane
        :label="tab.name"
        :name="index + ''"
        v-for="(tab, index) in tabs"
        :key="index"
      >
        <div class="lke-tab">
          <div class="lke-tab-l" v-html="tab.applyFrontTemplate"></div>
          <div class="lke-tab-r">
            <img :src="url + tab.qrcodeUrl" alt="" />
            <p>手机扫一扫</p>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getapplytpl } from "@/api/index";
import { getImgUrl } from "@/utils/auth";
export default {
  props: {},
  data() {
    return {
      loading: false,
      url: getImgUrl(),
      activeName: "0",
      url: "@/pages/index/assets/bird.jpeg",
      tabs: [],
    };
  },
  computed: {},
  created() {
    this.getapplytpl();
  },
  mounted() {},
  watch: {},
  methods: {
    getapplytpl() {
      this.loading = true;
      getapplytpl().then((response) => {
        let list = [];
        for (let index = 0; index < response.result.length; index++) {
          if (response.result[index].applytype === "registration") {
            list.push(response.result[index]);
          }
        }
        this.tabs = list;
        this.loading = false;
      });
    },
  },
  components: {},
};
</script>

<style>
.el-tabs__item {
  font-size: 18px !important;
  letter-spacing: 1px;
}
.el-tabs__item.is-active {
  font-weight: 600;
}
</style>

<style scoped>
.lke-titl {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  padding-bottom: 20px;
}
.lke-titl > div:first-child {
  display: flex;
  align-items: center;
}
.lke-titl i {
  color: #2890f4;
  padding-right: 5px;
  font-size: 20px;
}
.lke-mid {
  border: 1px solid #ccc;
  margin-bottom: 20px;
}
.lke-mid-top {
  padding: 10px 20px;
  font-size: 18px;
  color: #409eff;
  display: flex;
  align-items: center;
  font-weight: bold;
  border-bottom: 1px solid #ccc;
  background: #f7f7f7;
}
.lke-mid-top > i {
  font-size: 30px;
  padding-right: 20px;
}
.lke-mid-fot {
  padding: 20px 50px 20px 20px;
  line-height: 2;
}
.lke-tab1in-top > i {
  font-size: 18px;
  color: #409eff;
}
.lke-tab1in-fot {
  display: flex;
  align-items: center;
  padding: 10px 0;
  padding-left: 90px;
}
.lke-tab1in-fot > span {
  font-size: 14px;
  color: #888888;
  padding-right: 50px;
}
.lke-tab1in-fot > div {
  flex: 1;
}
.lke-tab {
  display: flex;
}
.lke-tab-l {
  flex: 1;
  color: #666666;
  padding: 30px 20px;
}
.lke-tab-l p {
  font-size: 16px;
  line-height: 2;
  text-indent: 30px !important;
}
.lke-tab-l span {
  line-height: 2;
  font-family: 仿宋_GB2312;
  font-size: 12pt;
  font-weight: bolder;
}
.lke-tab-r {
  width: 200px;
  text-align: center;
}
.lke-tab-r > img {
  width: 80%;
  padding: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/page/grzx/bmdj/bmdj.vue